export const CALENDAR_ITEM_CORNER_RARIUS = 5
export const outlookPrefix = 'Outlook'
